import React from 'react';
import PropTypes from 'prop-types';

import { currentLanguage, format, useMessages } from '../i18n';

// GST state codes (place of supply) for billing.
export const STATES = [
  ['35', 'Andaman and Nicobar Islands'], ['37', 'Andhra Pradesh'], ['12', 'Arunachal Pradesh'], ['18', 'Assam'],
  ['10', 'Bihar'], ['04', 'Chandigarh'], ['22', 'Chhattisgarh'], ['26', 'Dadra and Nagar Haveli and Daman and Diu'],
  ['07', 'Delhi'], ['30', 'Goa'], ['24', 'Gujarat'], ['06', 'Haryana'], ['02', 'Himachal Pradesh'],
  ['01', 'Jammu and Kashmir'], ['20', 'Jharkhand'], ['29', 'Karnataka'], ['32', 'Kerala'], ['38', 'Ladakh'],
  ['31', 'Lakshadweep'], ['23', 'Madhya Pradesh'], ['27', 'Maharashtra'], ['14', 'Manipur'], ['17', 'Meghalaya'],
  ['15', 'Mizoram'], ['13', 'Nagaland'], ['21', 'Odisha'], ['34', 'Puducherry'], ['03', 'Punjab'],
  ['08', 'Rajasthan'], ['11', 'Sikkim'], ['33', 'Tamil Nadu'], ['36', 'Telangana'], ['16', 'Tripura'],
  ['09', 'Uttar Pradesh'], ['05', 'Uttarakhand'], ['19', 'West Bengal'],
];

export function rupees(amount, decimals = false) {
  const n = Number(amount || 0);
  try {
    return new Intl.NumberFormat(`${currentLanguage()}-IN`, {
      style: 'currency', currency: 'INR', minimumFractionDigits: decimals ? 2 : 0, maximumFractionDigits: decimals ? 2 : 0,
    }).format(n);
  } catch (e) {
    return `₹${decimals ? n.toFixed(2) : Math.round(n)}`;
  }
}

// Price with MRP struck through and the discount, or "Free".
export const PriceTag = ({ price, size }) => {
  const t = useMessages();
  if (!price) { return null; }
  if (!price.paid) { return <span className={`bm-price is-free is-${size}`}>{t.shFree}</span>; }
  return (
    <span className={`bm-price is-${size}`}>
      <strong>{rupees(price.price)}</strong>
      {price.list_price && <s>{rupees(price.list_price)}</s>}
      {price.percent_off > 0 && <em>{format(t.shOff, { percent: price.percent_off })}</em>}
      {price.offer?.badge && <span className="bm-price__badge">{price.offer.badge}</span>}
    </span>
  );
};
PriceTag.propTypes = { price: PropTypes.shape({}), size: PropTypes.oneOf(['sm', 'md', 'lg']) };
PriceTag.defaultProps = { price: null, size: 'md' };

export const HeartIcon = ({ filled }) => (
  <svg className="bm-heart" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 20s-7-4.4-9.2-8.6C1.2 8.2 3 4.6 6.5 4.6c2 0 3.4 1.1 4.2 2.4h2.6c.8-1.3 2.2-2.4 4.2-2.4 3.5 0 5.3 3.6 3.7 6.8C19 15.6 12 20 12 20z"
      fill={filled ? 'currentColor' : 'none'} />
  </svg>
);
HeartIcon.propTypes = { filled: PropTypes.bool };
HeartIcon.defaultProps = { filled: false };

export const CartIcon = () => (
  <svg className="bm-cart-icon" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M3 4h2l2.4 10.5a2 2 0 002 1.5h7.7a2 2 0 001.9-1.4L21 8H6.2" />
    <circle cx="10" cy="20" r="1.4" /><circle cx="17" cy="20" r="1.4" />
  </svg>
);
